var map = {
	"./18_PW.png": 81002,
	"./19PW.png": 57966,
	"./20PW.png": 23931,
	"./21PW.png": 53988,
	"components/Catalog/PW/img/glass/lw/lwPlusGold/18_PW.png": 81002,
	"components/Catalog/PW/img/glass/lw/lwPlusGold/19PW.png": 57966,
	"components/Catalog/PW/img/glass/lw/lwPlusGold/20PW.png": 23931,
	"components/Catalog/PW/img/glass/lw/lwPlusGold/21PW.png": 53988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49506;